<p *ngIf="claimsHeading" margin-bottom-small-x [innerHTML]="claimsHeading"></p>

<ol *ngIf="orderedClaims; else defaultClaimList" class="claims" no-margin padding-left-large>
  <ng-template [ngTemplateOutlet]="claims"></ng-template>
</ol>

<ng-template #claims>
  <li *ngFor="let claim of $any(claimsList); trackBy: trackByValue" [innerHTML]="claim"></li>
</ng-template>

<rt-message margin-tb variant="context-warning" *ngIf="textUnderClaims">
  <p no-margin [innerHTML]="textUnderClaims"></p>
</rt-message>

<ng-template #defaultClaimList>
  <ul class="claims" no-margin padding-left>
    <ng-template [ngTemplateOutlet]="claims"></ng-template>
  </ul>
</ng-template>
